import React from 'react';
import { connect } from 'react-redux'
import { Tooltip, Button, Tag } from 'antd';
import {AdmsRepository} from '../../redux/AdmsActions';
import { subsetByLangOrEmpty } from '../../virtuoso/helper';

/** Отображение наложенных условий отбора */
class FilterGroup extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        this.state = {
            loading: false, 			//Флаг загрузки
        }
    }
    
    componentWillMount() { 
    }

    handleClose = (removedTag) => {
      const {onChange} = this.props;
      if (onChange) onChange(false, removedTag);
    }
    
  
    saveInputRef = input => this.input = input
  
    render() {
      //console.log(this);
      const { conditions } = this.props;
      return (
        <div style={{display: "inline"}}>
          {conditions.map((condition, i) =>             
            <span className="browserFilterSpan"  key={i}><Tag style={{display: "inline"}} closable={true} onClose={() => this.handleClose(condition)}>{condition.label || condition.value}</Tag></span>
          )}
          <Tooltip placement="right" title={"Очистить условия"}>
            <Button icon="delete" size="small" onClick={() => this.props.reset()}></Button>
          </Tooltip>
        </div>
      );
    }
  }

const makeConditions = (conditions, taxonomy, lang) => {
  //console.log("FilterData.js", conditions, taxonomy, lang)
  let tags = []
  conditions.forEach(condition => {
      const scheme = taxonomy.filter(item => item.IRI && item.IRI.value && (item.IRI.value == condition.scheme));
      if (Array.isArray(condition.value) && (condition.value.length>1) && (scheme.length >0)){        
        const concepts = subsetByLangOrEmpty(scheme[0].concepts, lang, "IRI", "Label")
        //console.log("FilterData.js", concepts)
        condition.value.forEach(value => {
          const advTag = JSON.parse(JSON.stringify(condition)); 
          advTag.value = value;
          const labels = concepts.filter(concept => concept.IRI.value == value)
          advTag.label = (labels.length>0)?labels[0].Label.value:value;
          tags = tags.concat(advTag) 
        })
      } else {
        tags = tags.concat(JSON.parse(JSON.stringify(condition))) 
      }
  })
  return tags;
}
const mapStateToProps = (state, props) => {
    return {
      conditions: makeConditions(state.vadms.conditions, state.vadms.taxonomy, state.vset.lang)
  };
};
const mapDispatchToProps = dispatch => {
  return {
    reset: () => dispatch(AdmsRepository.CONDITIONS([]))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterGroup);